module.exports = __webpack_public_path__ + "static/media/filter_5_white_18dp.1059f73a.svg";